import Vue from "vue";
import Router from "vue-router";
import Home from "./views/HomeView.vue";
import Resources from "./components/Resources.vue";
import Events from "./components/Events.vue";
import Courses from "./components/Courses.vue";
import Publication from "./components/Publication.vue";
import Inicio from "./components/Inicio.vue";
import NoticiaDetalle from "./components/NoticiaDetalle.vue";
import Evento from "./components/Evento.vue";
import Blanco from "./components/Blanco.vue";
//ABOUT
import About from "./components/About.vue";
import About1 from "./components/About1.vue";//mission
import About2 from "./components/About2.vue";//audience
import About3 from "./components/About3.vue";//entities
import About4 from "./components/About4.vue";//contactus
//RESOURCES
import TCorruption from "@/components/Tools/Corruption.vue";
import TCrimePrevention from "@/components/Tools/CrimePrevention.vue";
import TOrganizedCrime from "@/components/Tools/OrganizeCrime.vue";
import TDrug from "@/components/Tools/Drug.vue";
import TGender from "@/components/Tools/Gender.vue";
import TPrison from "@/components/Tools/Prison.vue";
import TTerrorism from "@/components/Tools/Terrorism.vue";
import TViolence from "@/components/Tools/Violence.vue";
import THomicides from "@/components/Tools/Homicides.vue";
//LOGIN
import Users from "@/components/Login/Users.vue";
import Login from "@/components/Login/Login.vue";
//COURSES
import CCorruption from "@/components/Cours/CCorruption.vue";
import COrganizeCrime from "@/components/Cours/COrganizeCrime.vue";
import CTerrorism from "@/components/Cours/CTerrorism.vue";
import CGender from "@/components/Cours/CGender.vue";
import CPrison from "@/components/Cours/CPrison.vue";
import CDrugs from "./components/Cours/CDrugs.vue";
import CHomicides from "./components/Cours/CHomicides.vue";
import CCrimePrevention from "./components/Cours/CCrimePrevention.vue";



Vue.use(Router);

const router =  new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        /*{
            path: "/",
            name: "Login",
            component: Login,
        },*/
        {
            path: "/",
            component: Inicio,
            meta: { requiresAuth: true}, // Indica que esta ruta requiere autenticación , allowedRoles: [6, 7, 8, 9] 
            children: [
                {
                    path: "/",
                    name: "Inicio",
                    component: Home,
                },
                {
                    path: "/",
                    name: "Login",
                    component: Login,
                },
                {
                    path: "/resources",
                    name: "resources",
                    component: Resources,
                },
                {
                    path: "/events",
                    name: "events",
                    component: Events,
                },        
                {
                    path: "/courses",
                    name: "courses",
                    component: Courses,
                },
                {
                    path: "/publication/:id",
                    name: "publication",
                    component: Publication,
                },
                {
                    path: "/about/:id",
                    name: "about",
                    component: About,
                },
                {
                    path: "/about1/:id",
                    name: "about1",
                    component: About1,
                },
                {
                    path: "/about2/:id",
                    name: "about2",
                    component: About2,
                },
                {
                    path: "/about3/:id",
                    name: "about3",
                    component: About3,
                },
                {
                    path: "/about4/:id",
                    name: "about4",
                    component: About4,
                },
                {
                    path: "/inicio",
                    name: "inicio",
                    component: Inicio,
                },
                {
                    path: "/noticiadetalle/:id",
                    name: "noticiadetalle",
                    component: NoticiaDetalle,
                }, 
                {
                    path: "/evento",
                    name: "evento",
                    component: Evento,
                }, 
                {
                    path: "/blanco",
                    name: "blanco",
                    component: Blanco,
                },
                {
                    path: "/TCorruption/:id",
                    name: "TCorruption",
                    component: TCorruption,
                },
                {
                    path: "/TCrimePrevention/:id",
                    name: "TCrimePrevention",
                    component: TCrimePrevention,
                },
                {
                    path: "/TOrganizedCrime/:id",
                    name: "TOrganizedCrime",
                    component: TOrganizedCrime,
                },
                {
                    path: "/TDrug/:id",
                    name: "TDrug",
                    component: TDrug,
                },
                {
                    path: "/TGender/:id",
                    name: "TGender",
                    component: TGender,
                },
                {
                    path: "/TPrison/:id",
                    name: "TPrison",
                    component: TPrison,
                },
                {
                    path: "/TTerrorism/:id",
                    name: "TTerrorism",
                    component: TTerrorism,
                },
                 {
                    path: "/CHomicides/:id",
                    name: "CHomicides",
                    component: CHomicides,
                },
                {
                    path: "/CCorruption/:id",
                    name: "CCorruption",
                    component: CCorruption,
                },
                {
                    path: "/COrganizeCrime/:id",
                    name: "COrganizeCrime",
                    component: COrganizeCrime,
                },
                {
                    path: "/CTerrorism/:id",
                    name: "CTerrorism",
                    component: CTerrorism,
                },
                {
                    path: "/CGender/:id",
                    name: "CGender",
                    component: CGender,
                },
                {
                    path: "/CPrison/:id",
                    name: "CPrison",
                    component: CPrison,
                },
                {
                    path: "/Users/",
                    name: "Users",
                    component: Users,
                },
                {
                    path: "/CDrugs/:id",
                    name: "CDrugs",
                    component: CDrugs,
                },
                {
                    path: "/TViolence/:id",
                    name: "TViolence",
                    component: TViolence,
                },
                  {
                    path: "/THomicides/:id",
                    name: "THomicides",
                    component: THomicides,
                },
                   {
                    path: "/CCrimePrevention/:id",
                    name: "CCrimePrevention",
                    component: CCrimePrevention,
                },
            ]
        },
    ],
});

export default router;